import React, { useState, useEffect } from "react";
//css
import "./PhoneNumberVerification.css";
//components
import Breadcrumbs from "../Components/Breadcrumbs";
import Step1Breakcrumbs from "../Components/Step1Breakcrumbs";
//functions
import patchStepCount from "../Functions/patchStepCount";
import getCookieParam from "../Functions/getCookieParam";
import apiComponents from "../Functions/apiComponents";

const SubStep1 = (props) => { //step 1
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Do you have a number to integrate with<br />WhatsApp Business Account?</h2>
                <div className="step1-buttons-container">
                    <button className="red-button" onClick={async event => { if (await patchStepCount(1, 1, 2, 4) === 'updated') props.changeCount("2") }}>Yes</button>
                    <button className="grey-button" onClick={event => props.changeCount("1.1")}>No</button>
                </div>
            </div>
            <Step1Breakcrumbs subStep={1} />
            <div>Already have an account on 360dialog? <a href={"/" + getCookieParam('partnerName') + "/whatsapp-onboarding"} className="link">Login</a></div>
        </>
    );
}

const SubStep1dot1 = (props) => {
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Kindly procure a new number that can be integrated<br />with WhatsApp</h2>
                <div style={{ fontSize: "20px", marginBottom: "-32px" }}>Kindly ensure that the number is:</div>
                <ul>
                    <li>Not currently active on WhatsApp</li>
                    <li>Can receive OTP from US/UK phone number</li>
                </ul>
            </div>
            <Step1Breakcrumbs subStep={1} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("1")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep2 = (props) => { //step 2
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Is this number active on IVR?</h2>
                <div className="step1-buttons-container">
                    <button className="red-button" onClick={event => props.changeCount("3")}>Yes</button>
                    <button className="grey-button" onClick={async event => { if (await patchStepCount(1, 2, 4, 8) === 'updated') props.changeCount("4") }}>No</button>
                </div>
            </div>
            <Step1Breakcrumbs subStep={2} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("1")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep3 = (props) => { // step 3
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Can you deactivate IVR for 15 minutes?</h2>
                <div className="step1-buttons-container">
                    <button className="red-button" onClick={async event => { if (await patchStepCount(1, 3, 4, 12) === 'updated') props.changeCount("4") }}>IVR deactivated</button>
                    <button className="grey-button" onClick={event => props.changeCount("3.1")}>No</button>
                </div>
            </div>
            <Step1Breakcrumbs subStep={3} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("2")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep3dot1 = (props) => {
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">
                    We will provide you with two sender IDs (usually US +1 or UK +44 numbers).<br />
                    The registration call will arrive on one of these sender IDs.
                    You must use this information to create a whitelist or redirect for those numbers — so that once the call comes in, it is redirected to an employee or mailbox or receiver where the registration code will be captured.
                </h2>
                <div style={{ fontSize: "20px" }}>
                    Please contact support to get this done
                </div>
                <div className="step1-buttons-container">
                    <button style={{ display: "none" }} className="red-button" href="mailto:support@engati.com?subject=Need sender IDs for IVR">Contact Support</button>
                </div>
            </div>
            <Step1Breakcrumbs subStep={3} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("3")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep4 = (props) => { //step 4
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Was this number registered or ever active on <br /> WhatsApp?</h2>
                <div className="step1-buttons-container">
                    <button className="red-button" onClick={async event => { if (await patchStepCount(1, 4, 5, 16) === 'updated') props.changeCount("5") }}>Yes</button>
                    <button className="grey-button" onClick={async event => { if (await patchStepCount(1, 4, 9, 16) === 'updated') props.changeCount("9") }}>No</button>
                </div>
            </div>
            <Step1Breakcrumbs subStep={4} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("3")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep5 = (props) => { //step 5
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Is this number registered with a WhatsApp<br /><a style={{ fontWeight: "600" }} className="link" href="https://faq.whatsapp.com/1825026610975153/?locale=en_US" target="_blank" rel="noopener noreferrer">Business Service Provider?</a></h2>
                <div className="step1-buttons-container">
                    <button className="red-button" onClick={async event => { if (await patchStepCount(1, 5, 6, 20) === 'updated') props.changeCount("6") }}>Yes</button>
                    <button className="grey-button" onClick={async event => { if (await patchStepCount(1, 5, 8, 20) === 'updated') props.changeCount("8") }}>No</button>
                </div>
            </div>
            <Step1Breakcrumbs subStep={5} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("4")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep6 = (props) => { //step 6
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Is the number active with 360dialog Business<br />Service Provider?</h2>
                <div className="step1-buttons-container">
                    <button className="red-button" onClick={async event => { if (await patchStepCount(1, 6, 7, 24) === 'updated') props.changeCount("7") }}>Yes</button>
                    <button className="grey-button" onClick={event => props.changeCount("6.1")}>No</button>
                </div>
            </div>
            <Step1Breakcrumbs subStep={6} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("5")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep6dot1 = (props) => {
    const partnerId = apiComponents.partnerId;
    const checkboxFunc = () => {
        document.getElementsByClassName('red-button')[0].disabled = true;
        let check = true;
        Array.from(document.getElementsByTagName('input')).forEach(item => {
            if (item.getAttribute('type') === 'checkbox' && item.checked === false) {
                check = false;
            }
        });
        if (check === true) document.getElementsByClassName('red-button')[0].disabled = false;
    }
    useEffect(() => { document.getElementById('preRequisitesButton').disabled = true });
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Pre-requisites needed for migration:</h2>
                <div>
                    <form className={'checkbox-form'}>
                        <div>
                            <input type="checkbox" onChange={event => checkboxFunc()} />
                            Ability to receive 6 digit OTP on the existing number via Call or SMS
                        </div>
                        <div>
                            <input type="checkbox" onChange={event => checkboxFunc()} />
                            WhatsApp account must be verified. Sandbox accounts cannot<br />be migrated. Check status of your verification here
                        </div>
                        <div>
                            <input type="checkbox" onChange={event => checkboxFunc()} />
                            Two-Factor Verification<a className="link" href="https://developers.facebook.com/docs/whatsapp/on-premises/reference/settings/two-step-verification#disable" target="_blank" rel="noopener noreferrer">must be disabled for the number</a>
                        </div>
                    </form>
                </div >
                <div className="step1-buttons-container">
                    <a id="preRequisitesButton" className="red-button" href={`https://hub.360dialog.com/lp/migrate/${partnerId}`} target="_blank" rel="noopener noreferrer">Continue</a>
                </div>
            </div>
            <Step1Breakcrumbs subStep={6} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("6")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep7 = (props) => { //step 7
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading" style={{ marginBottom: 0 }}>Kindly fill the partner change request form to setup</h2>
                <div style={{ fontSize: "20px" }}>Click on the button below to continue:</div>
                <div className="step1-buttons-container">
                    <a className="grey-button" href="https://docs.360dialog.com/docs/360-client-hub/partner-change" target="_blank" rel="noopener noreferrer">Continue</a>
                </div>
            </div>
            <Step1Breakcrumbs subStep={7} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("6")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep8 = (props) => { //step 8
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Was this number active on<br /><a style={{ fontWeight: "600" }} className="link" href="https://faq.whatsapp.com/988069844889223/?helpref=hc_fnav" target="_blank" rel="noopener noreferrer">WhatsApp Business Application?</a></h2>
                <div className="step1-buttons-container">
                    <button className="red-button" onClick={event => props.changeCount("8.1")}>Yes</button>
                    <button className="grey-button" onClick={async event => { if (await patchStepCount(1, 8, 9, 32) === 'updated') props.changeCount("9") }}>No</button>
                </div>
            </div>
            <Step1Breakcrumbs subStep={8} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("5")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep8dot1 = (props) => {
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading" style={{ marginBottom: 0 }}>Delete your WhatsApp account to proceed further.</h2>
                <div style={{ fontSize: "20px" }}>Click on the button below for more information:</div>
                <div className="step1-buttons-container">
                    <a className="grey-button" href="https://faq.whatsapp.com/android/account-and-profile/how-to-delete-your-account" target="_blank" rel="noopener noreferrer">Know more</a>
                </div>
            </div>
            <Step1Breakcrumbs subStep={8} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("4")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep9 = (props) => { //step 9
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Can this number receive OTP either via call or SMS<br />from a US/UK number?</h2>
                <div className="step1-buttons-container">
                    <button className="red-button" onClick={async event => { if (await patchStepCount(1, 9, 10, 36) === 'updated') props.changeCount("10") }}>Yes</button>
                    <button className="grey-button" onClick={event => props.changeCount("9.1")}>No</button>
                </div>
            </div>
            <Step1Breakcrumbs subStep={9} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("8")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep9dot1 = (props) => {
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Kindly procure a new number that can receive an OTP,<br />via SMS or phone call</h2>
            </div>
            <Step1Breakcrumbs subStep={9} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("9")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep10 = (props) => { //step 10
    return (
        <>
            <div className="step1-body">
                <h2 className="secondary-heading">Do you have a verified <a style={{ fontWeight: "600" }} className="link" href="https://www.facebook.com/business/help/113163272211510?id=180505742745347" target="_blank" rel="noopener noreferrer">Facebook Business Manager</a><br />account?</h2>
                <div className="step1-buttons-container">
                    <button className="red-button" onClick={async event => { if (await patchStepCount(2, 10, 10, 40) === 'updated') window.location.pathname = `/${getCookieParam('partnerName')}/whatsapp-onboarding` }}>Yes</button>
                    <button className="grey-button" onClick={event => props.changeCount("10.1")}>No</button>
                </div>
            </div>
            <Step1Breakcrumbs subStep={10} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("9")}>{"<<"} Previous Step</div>
        </>
    );
}

const SubStep10dot1 = (props) => {
    const [country, setCountry] = useState('');
    return (
        <>
            <div className="step1-body" style={{ gridRowGap: "0" }}>
                <h2 className="secondary-heading">Document Checklist:</h2>
                <select className="input" onChange={event => setCountry(event.currentTarget.value)}>
                    <option value="">Select country</option>
                    <option value="Brazil">Brazil</option>
                    <option value="China">China</option>
                    <option value="Cyprus">Cyprus</option>
                    <option value="France">France</option>
                    <option value="India">India</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Ireland">Ireland</option>
                    <option value="Italy">Italy</option>
                    <option value="Japan">Japan</option>
                    <option value="South Korea">South Korea</option>
                    <option value="Taiwan">Taiwan</option>
                    <option value="UAE">UAE</option>
                    <option value="Ukraine">Ukraine</option>
                    <option value="United Kingdom">United Kingdom</option>
                    <option value="United States">United States</option>
                </select>
                <DocsComponent country={country} />
                <div className="step1-buttons-container" style={{ display: 'none' }}>
                    <a className="red-button" href="https://www.facebook.com/micro_site/url/?click_from_context_menu=true&country=IN&destination=https%3A%2F%2Fbusiness.facebook.com%2Fsettings%2Fsecurity&event_type=click&last_nav_impression_id=0UKymzcxK0EY10Cfk&max_percent_page_viewed=52&max_viewport_height_px=861&max_viewport_width_px=1680&orig_http_referrer=https%3A%2F%2Fwww.facebook.com%2Fbusiness%2Fhelp%2F159334372093366&orig_request_uri=https%3A%2F%2Fwww.facebook.com%2Fbusiness%2Fhelp%2F2058515294227817&primary_cmsid=2058515294227817&primary_content_locale=en_US&region=apac&scrolled=true&session_id=1ZDB5SHsxUURL6mcB&site=fb4b&extra_data[view_type]=v3_initial_view&extra_data[site_section]=help&extra_data[placement]=%2Fbusiness%2Fhelp%2F2058515294227817" target="_blank" rel="noopener noreferrer">Apply for verification</a>
                    <a className="grey-button" href="https://www.facebook.com/business/help/159334372093366" target="_blank" rel="noopener noreferrer">Know more</a>
                </div>
            </div>
            <Step1Breakcrumbs subStep={10} />
            <div style={{ cursor: "pointer" }} onClick={event => props.changeCount("10")}>{"<<"} Previous Step</div>
        </>
    );
}

const DocsComponent = (props) => {
    //show or hide buttons
    if (props.country !== '') { document.getElementsByClassName('step1-buttons-container')[0].style.display = "flex"; }
    else { document.getElementsByClassName('step1-buttons-container')[0].style.display = "none"; }
    //return list of documents based on country name
    if (props.country === 'Brazil') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>Business bank statement</li>
                        <li>Cadastro Nacional da Pessoa Juridica (CNPJ)</li>
                        <li>Certificado da Condicao de Microempreendedor Individual (MEI)</li>
                        <li>Contrato Social</li>
                        <li>Utility bill</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'China') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>公司註冊證書</li>
                        <li>商業登記摘錄</li>
                        <li>商業登記證</li>
                        <li>营业执照</li>
                        <li>銀行帳單</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'Cyprus') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>Αντίγραφο κίνησης λογαριασμού / Hesap özeti</li>
                        <li>Εγγραφή στο μητρώο Φ.Π.Α.</li>
                        <li>Καταστατικό / Şirket ana sözleşmesi</li>
                        <li>Μητρώο Επιχειρηματικών Οντοτήτων</li>
                        <li>Συστατική Πράξη Εταιρείας / Şirket Kuruluş Onay Belgesi</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'France') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>Avis de situation au repertoire Sirene</li>
                        <li>Extrai d'immatriculation D1</li>
                        <li>Extrait K, L, Kbis ou Lbis</li>
                        <li>Facture d'électricité, de gaz ou d'eau</li>
                        <li>Lettre de confirmation de numéro SIREN délivrée par l'Urssaf</li>
                        <li>Statuts de l'enterprise</li>
                        <li>VAT registration</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'India') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>Business bank statement</li>
                        <li>Business licence</li>
                        <li>Certificate of incorporation</li>
                        <li>Goods and services tax registration certificate (GST)</li>
                        <li>Permanent account number card (PAN)</li>
                        <li>Shop establishment certificate</li>
                        <li>Udyog Aadar (UID)</li>
                        <li>Utility bill</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'Indonesia') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>Business bank statement</li>
                        <li>Izin Usaha Mikro Kecil (IUMK)</li>
                        <li>Nomar Induk Berusaha (NIB)</li>
                        <li>Surat Izin Usaha Perdagangan (SIUP)</li>
                        <li>Surat Pengukuhan Pengusaha Kena Pajak (SPPKP)</li>
                        <li>Tanda Daftar Perusahaan (TDP)</li>
                        <li>Utility bill</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'Ireland') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>An Oifig um Chlárú Cuideachtaí</li>
                        <li>Business bank statement</li>
                        <li>Business tax certificate</li>
                        <li>Certificate of business incorporation</li>
                        <li>Certificate of registration</li>
                        <li>Utility bill</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'Italy') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>Atto Costitutivo</li>
                        <li>Certificato di Registrazione Aziendale</li>
                        <li>Registro Imprese dell'archivio ufficiale della CCIAA</li>
                        <li>Statuto</li>
                        <li>Business bank statement</li>
                        <li>Certificate of formation</li>
                        <li>Utility bill</li>
                        <li>Value-added tax certificate (VAT)</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'Japan') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>個人事業の開業, 廃業等の届出書</li>
                        <li>営業許可</li>
                        <li>定款</li>
                        <li>履歴事項全部証明書</li>
                        <li>法人番号指定通知書</li>
                        <li>納税証明書</li>
                        <li>Business bank statement</li>
                        <li>Utility bill</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'South Korea') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>사업자등록증</li>
                        <li>요금납부 내역서</li>
                        <li>지방세 납세 증명서</li>
                        <li>지방세 납세 증명서</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'Taiwan') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>台中市政府函</li>
                        <li>有限公司设立登记表</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'UAE') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>Certificate of formation</li>
                        <li>رخصة تجارية</li>
                        <li>شهادة تسجيل لضريبة القيمة المضافة</li>
                        <li>فاتورة اتصالات</li>
                        <li>فاتورة الكهرباء</li>
                        <li>كشف حساب بنك</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'Ukraine') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>Виписка з єдиного державного реєстру юридичних осіб , фізичних осіб-підприємців та громадьских формувань</li>
                        <li>Виписка з єдиного державного реєстру юридичних осіб та фізичних осіб-підприємців</li>
                        <li>Витяг з реєстру платників єдиного податку</li>
                        <li>Свідоцтво платника єдиного податку</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'United Kingdom') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>Business bank statement</li>
                        <li>Certificate of incorporation</li>
                        <li>Certificate of public liability insurance</li>
                        <li>Companies House document</li>
                        <li>Company registration number (CRN)</li>
                        <li>HM Revenue and Customs: VAT certificate</li>
                        <li>HM Revenue and Customs: Account statement</li>
                        <li>Utility bill</li>
                    </ul>
                </div>
            </>
        )
    }
    else if (props.country === 'United States') {
        return (
            <>
                <div>
                    <h2 className="secondary-heading" style={{ fontSize: '16px' }}>Ensure that you have one of the following documents available:</h2>
                    <ul>
                        <li>Articles of incorporation</li>
                        <li>Business bank statement</li>
                        <li>Business licence</li>
                        <li>Employer identification number (EIN)</li>
                        <li>IRS SS-4 (EIN assignment letter)</li>
                        <li>IRS 147c (EIN confirmation letter)</li>
                        <li>Taxpayer identification number</li>
                    </ul>
                </div>
            </>
        )
    }
}

function SwitchComponents({ active, children }) { return children.filter(child => child.props.count === active) }

const PhoneNumberVerification = () => {
    if (getCookieParam('token') === '') window.location.pathname = `/${getCookieParam('partnerName')}`;
    const [stepCount, setStepCount] = useState(getCookieParam('subStep'));
    return (
        <div className="step1-container">
            <Breadcrumbs />
            <SwitchComponents active={stepCount}>
                <SubStep1 count="1" changeCount={setStepCount} />
                <SubStep1dot1 count="1.1" changeCount={setStepCount} />
                <SubStep2 count="2" changeCount={setStepCount} />
                <SubStep3 count="3" changeCount={setStepCount} />
                <SubStep3dot1 count="3.1" changeCount={setStepCount} />
                <SubStep4 count="4" changeCount={setStepCount} />
                <SubStep5 count="5" changeCount={setStepCount} />
                <SubStep6 count="6" changeCount={setStepCount} />
                <SubStep6dot1 count="6.1" changeCount={setStepCount} />
                <SubStep7 count="7" changeCount={setStepCount} />
                <SubStep8 count="8" changeCount={setStepCount} />
                <SubStep8dot1 count="8.1" changeCount={setStepCount} />
                <SubStep9 count="9" changeCount={setStepCount} />
                <SubStep9dot1 count="9.1" changeCount={setStepCount} />
                <SubStep10 count="10" changeCount={setStepCount} />
                <SubStep10dot1 count="10.1" changeCount={setStepCount} />
            </SwitchComponents>
        </div>
    );
}

export default PhoneNumberVerification;